  $(document).ready(function(){
    
    // If the page content dom ele and url contain product handel.
    if( $(".variant-box").length > 1 && window.location.pathname.indexOf('/products/') == 0){

        // on box selection click
        $(".variant-box").click(function(){

            // clicked var_id
            var sel_vid = $(this).attr('variant-id');
            
            // box selection logic
            $(".variant-box").removeClass("is_selected_cu");
            $(this).addClass('is_selected_cu');

            var $d, $product_info_compare;
            var push_price, v_price, m_price, price_normal, price_slacked;
            $product_info_compare = $(".product-info__price").find("compare-at-price");
             
            // set updated url parameter
            const url_in = new URL(window.location.href);
            url_in.searchParams.set('respawn', '1'); 
            url_in.searchParams.set('variant', sel_vid);
            window.history.pushState(null, '', url_in.toString());
             
             // set hidden parameter for variant change on page load
            $d = $(".product-info__buy-buttons").find("[name='id']");
            $d.attr("value", sel_vid);
 
             // emulate click for hidden parameter
            push_price = $(".variant-box[variant-id='"+ sel_vid +"']").find('label').attr('for');
            $('#' + push_price).click();
             
             
            // remove hidden tags and replace class
            $product_info_compare.removeAttr("hidden");
             
 
            // Place the classes only when duplicate does not exist( for main price )
            if( $product_info_compare.find('span.money').length < 1 ){
                $product_info_compare.find("span.sr-only").removeClass('sr-only').addClass("money");
            }
            
            // get variant price
            v_price = $(".variant-box[variant-id='"+ sel_vid +"']").find('.vpricebox').find(".money");
            
            // Replace the main price on page load
            // When price slack is not present
            if( v_price.length < 2 ){
                price_normal = v_price.get(0).innerHTML;
                price_slacked = '';
                 
            }else{
                price_normal = v_price.get(0).innerHTML;
                price_slacked = v_price.get(1).innerHTML;
                
            }

            // place them.
            m_price = $(".product-info__price").find(".money");
            m_price.get(1).innerHTML = price_normal;
            m_price.get(0).innerHTML = price_slacked;
        });
        
        // check url parameter for first load
        var respawn = GetParameterValues("respawn");

        // To check if a URL is of particular product
        if (window.location.href.includes("moringa-a2-ghee")) {
            // get second product variant or any, starts from 0.
            var default_var = $(".variant-box:eq(0)").attr("variant-id");
        } else {
            // get second product variant or any, starts from 0.
            var default_var = $(".variant-box:eq(1)").attr("variant-id");
        }
        
        // on page load adjust selection based on url parameter
        var v_select = GetParameterValues("variant");

        // on page load set
        $(".variant-box").each(function(){
            if($(this).attr('variant-id') == v_select){
             
                $(".variant-box").not(this).removeClass("is_selected_cu");
                $(this).addClass('is_selected_cu');
                return false;
 
            }
        });


        if( typeof respawn == 'undefined' ){

            var $d, $product_info_compare;
            var push_price, v_price, m_price, price_normal, price_slacked;
            $product_info_compare = $(".product-info__price").find("compare-at-price");
            

            // box selection logic
            $(".variant-box").removeClass("is_selected_cu");
            $(".variant-box[variant-id='"+ default_var +"']").addClass('is_selected_cu');
            
            // set updated url parameter
            const url = new URL(window.location.href);
            url.searchParams.set('respawn', '1'); 
            url.searchParams.set('variant', default_var);
            window.history.pushState(null, '', url.toString());
            
            // set hidden parameter for variant change on page load
            $d = $(".product-info__buy-buttons").find("[name='id']");
            $d.attr("value", default_var);

            // emulate click for hidden parameter
            push_price = $(".variant-box[variant-id='"+ default_var +"']").find('label').attr('for');
            $('#' + push_price).click();
            
            // remove hidden tags and replace class
            $product_info_compare.removeAttr("hidden");
            
            // Place the classes only when duplicate does not exist( for main price )
            if( $product_info_compare.find('span.money').length < 1 ){
                $product_info_compare.find("span.sr-only").removeClass('sr-only').addClass("money");
            }
            
            // get variant price
            v_price = $(".variant-box[variant-id='"+ default_var +"']").find('.vpricebox').find(".money");
           
            
            // Replace the main price on page load
            // When price slack is not present
            if( v_price.length < 2 ){
                price_normal = v_price.get(0).innerHTML;
                price_slacked = '';
            }else{
                price_normal = v_price.get(0).innerHTML;
                price_slacked = v_price.get(1).innerHTML;
                }
                
            // place them
            m_price = $(".product-info__price").find(".money");
            m_price.get(1).innerHTML = price_normal;
            m_price.get(0).innerHTML = price_slacked;
            
        }
            
        function GetParameterValues(param) {
            var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
            for (var i = 0; i < url.length; i++) {
                var urlparam = url[i].split('=');
                if (urlparam[0] == param) {
                    return urlparam[1];
                }
            }
        }
    }



    //console.log(window.location.pathname.indexOf('/cart/'));
    
    // inititate main quantity changer
    attachCartEvents();

    // attach event listner for the cart change
    document.addEventListener("cart:change", function(){
       
        //console.log('kevin');
        
        setTimeout(function(){
            attachCartEvents();
        }, 2000);
    }); 

    // update cart items
    function updateCartItem( variant_id, quantity, operation){
        
        //co
        var data = { updates: {} };
        var item_count;
        //var data = [{ quantity: quantity, id: variant_id }];
        data.updates[variant_id] = quantity;
        
        $(".loading_wait").show();
        $(".loading_overlay").show();

        jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: data,
            dataType: 'json',
            success: function(result) { 
               
                $.when( 
                    jQuery.getJSON('/cart.js', function(cart) {
                        
                        item_count = cart.item_count;
                        let cartData = cart.items;
                        document.dispatchEvent(new CustomEvent('cart:build' ,{
                                bubbles: true
                            }
                        )); 
                        document.dispatchEvent(new CustomEvent('cart:refresh', {
                            bubbles: true,
                            detail: cartData
                        })); 
                    })
                ).then(function(){
                    
                    setTimeout(function(){
                        
                        // don't re-attach
                        if( window.location.pathname.indexOf('/cart/') == -1)
                            attachCartEvents();

                        $(".header__cart-count").find(".count-bubble").html(item_count);
                        $(".loading_wait").hide();
                        $(".loading_overlay").hide();
                        
                        // console.log('re-attached');
                    }, 2000);

                });
            }
        });
    }

    // main function for event attaching event listners
    function attachCartEvents(){
        $(".i_minus_cart").click(function(){
            //console.log("MINUS");
            
            var minus;
            
            let $inputBox = $(this).parents('.line_changer').find('input.quantity-input');

            minus = parseInt( $inputBox.attr('value') ) - 1;
            
            $inputBox.attr('value', minus);
            
            //console.log($inputBox.attr('value'));
            //console.log(minus);
            //$(this).parents('.line-item').find('.line_item_hdn').find('input.quantity-input').attr('value', minus);
    
            var variant_id = $(this).parents('.line_changer').attr("line_var_id");
          
            updateCartItem(variant_id, minus, 'minus'); 
    
        });
        
        $(".i_plus_cart").click(function(){
            //console.log('PLUS')
            
            var plus, max, currrent_qty;
            let $inputBox = $(this).parents('.line_changer').find('input.quantity-input');
            
            currrent_qty = parseInt( $inputBox.attr('value') );
            plus = currrent_qty + 1;
                
            $inputBox.attr('value', plus);

            //console.log(currrent_qty);
            //console.log(plus);
            //$(this).parents('.line-item').find('.line_item_hdn').find('input.quantity-input').attr('value', plus);

            var variant_id = $(this).parents('.line_changer').attr("line_var_id");
            updateCartItem(variant_id, plus, 'plus'); 
    
        });
    }
});



// === FEATURED REVIEW FLEX ===
$('.featured_review_flex').slick({
  dots: false,
  arrows: false,
  infinite: false,
  speed: 400,
  slidesToShow: 3.7,
  slidesToScroll: 1,   // 🔥 1 slide only
  swipeToSlide: true,
  draggable: true,
  touchThreshold: 8,
  cssEase: 'ease-in-out',

  responsive: [
    {
      breakpoint: 1220,
      settings: {
        slidesToShow: 3.4,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        dots: true
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '40px',
        infinite: true,
        dots: true
      }
    }
  ]
});


// -----------------------------
//  SMOOTH MOUSEPAD SCROLL LOGIC
// -----------------------------

let scrolling = false;

$('.featured_review_flex').on('wheel', function (e) {
  const deltaX = e.originalEvent.deltaX;
  const deltaY = e.originalEvent.deltaY;

  // Only react to horizontal gestures
  if (Math.abs(deltaX) > Math.abs(deltaY)) {
    e.preventDefault();

    if (scrolling) return;
    scrolling = true;

    if (deltaX > 0) {
      $(this).slick('slickNext');  // → next slide
    } else {
      $(this).slick('slickPrev');  // ← previous slide
    }
    // Unlock after animation
    setTimeout(() => scrolling = false, 420);
  }
});

// collection card js

$(document).ready(function () {

  // -----------------------------
  // INITIALIZE SLICK
  // -----------------------------
 $('.collection_flex').slick({
  dots: true,
  arrows: false,
  infinite: false,
  speed: 400,
  slidesToShow: 3,
  slidesToScroll: 1,
  swipe: true,
  draggable: true,
  cssEase: 'ease-in-out',

  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.5
      }
    },
    {
      breakpoint: 580,
      settings: {
        slidesToShow: 1.2
      }
    }
  ]
});

// ----------------------------------
// SAFE TRACKPAD SUPPORT (NO SCROLL BLOCK)
// ----------------------------------

const isTouchDevice =
  'ontouchstart' in window || navigator.maxTouchPoints > 0;

let wheelLock = false;

$('.collection_flex').on('wheel', function (e) {

  // ✅ allow page scroll always
  if (isTouchDevice) return;

  // ONLY horizontal scroll should control slider
  if (Math.abs(e.originalEvent.deltaX) < Math.abs(e.originalEvent.deltaY)) {
    return; // vertical scroll → let page scroll
  }

  if (wheelLock) return;
  wheelLock = true;

  if (e.originalEvent.deltaX > 0) {
    $(this).slick('slickNext');
  } else {
    $(this).slick('slickPrev');
  }

  setTimeout(() => {
    wheelLock = false;
  }, 450);
});


});




// make us js

$(document).ready(function () {

  // -----------------------------
  // INITIALIZE SLICK
  // -----------------------------
  $('.brand_usp_flex').slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 400,
    slidesToShow: 3,
    slidesToScroll: 1,

    swipeToSlide: true,
    draggable: true,
    touchThreshold: 8,

    cssEase: 'ease-in-out',

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.4,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  });

  // -----------------------------
  // SMOOTH TRACKPAD SCROLL
  // -----------------------------
  // let scrolling = false;
  // const isTouchDevice =
  //   'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // $('.brand_usp_flex').off('wheel');

  // $('.brand_usp_flex').on('wheel', function (e) {

  //   // ✅ STOP double slide on mobile
  //   if (isTouchDevice) return;

  //   const deltaX = e.originalEvent.deltaX;
  //   const deltaY = e.originalEvent.deltaY;

  //   // Only horizontal scroll
  //   if (Math.abs(deltaX) > Math.abs(deltaY)) {
  //     e.preventDefault();

  //     if (scrolling) return;
  //     scrolling = true;

  //     if (deltaX > 0) {
  //       $(this).slick('slickNext');
  //     } else {
  //       $(this).slick('slickPrev');
  //     }

  //     setTimeout(() => {
  //       scrolling = false;
  //     }, 420);
  //   }
  // });

});




// faq page js
document.addEventListener("DOMContentLoaded", function () {
  const faqWrapper = document.querySelector(".faq_tab_sec");

  if (faqWrapper) {
    window.addEventListener("scroll", function () {
      if (window.scrollY > 200) {
        faqWrapper.classList.add("fixed");
      } else {
        faqWrapper.classList.remove("fixed");
      }
    });
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tab-button');
  const margin = 120; // small extra space from header

  tabs.forEach(tab => {
    tab.addEventListener('click', function(e) {
      e.preventDefault();
      tabs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');

      const section = document.querySelector(this.getAttribute('href'));
      if (section) {
        const header = document.querySelector('header'); // your fixed header
        const headerHeight = header ? header.offsetHeight : 0;

        const sectionPosition = section.getBoundingClientRect().top + window.scrollY;
        const scrollPosition = sectionPosition - headerHeight - margin;

        window.scrollTo({
          top: scrollPosition,
          behavior: 'smooth'
        });
      }
    });
  });
});




document.addEventListener("DOMContentLoaded", function () {
  // Select all FAQ sections
  const faqSections = document.querySelectorAll(".faq-section");

  faqSections.forEach(section => {
    const faqItems = section.querySelectorAll(".faq-item");

    // First FAQ open by default in this section
    if (faqItems.length > 0) {
      const first = faqItems[0];
      const firstBtn = first.querySelector(".faq-question");
      const firstAns = first.querySelector(".faq-answer");

      first.classList.add("open");
      firstBtn.setAttribute("aria-expanded", "true");
      firstAns.style.display = "block";
    }

    // Add click event for each question in this section only
    const questionButtons = section.querySelectorAll(".faq-question");

    questionButtons.forEach(button => {
      button.addEventListener("click", () => {
        const parent = button.closest(".faq-item");
        const expanded = button.getAttribute("aria-expanded") === "true";

        // Close all FAQs in this section
        faqItems.forEach(item => {
          item.classList.remove("open");
          const btn = item.querySelector(".faq-question");
          const ans = item.querySelector(".faq-answer");
          if (btn) btn.setAttribute("aria-expanded", "false");
          if (ans) ans.style.display = "none";
        });

        // If clicked one was closed → open it
        if (!expanded) {
          parent.classList.add("open");
          button.setAttribute("aria-expanded", "true");
          const answer = parent.querySelector(".faq-answer");
          if (answer) answer.style.display = "block";
        }
      });
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const stickyATC = document.querySelector(".product-quick-add");
  if (!stickyATC) return;

  const scrollOffset = 300; // show after 300px scroll (adjust as needed)

  function toggleStickyATC() {
    if (window.scrollY > scrollOffset) {
      stickyATC.classList.add("is-visible");
    } else {
      stickyATC.classList.remove("is-visible");
    }
  }

  window.addEventListener("scroll", toggleStickyATC);
});



//pdp section js

$(document).ready(function () {

  // -----------------------------
  // INITIALIZE SLICK
  // -----------------------------
  $('.way_to_use_flex').slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 400,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    draggable: true,
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          slidesToShow:2.5,
          slidesToScroll: 1,
          dots: true
        }
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
          dots: true
        }
      }
    ]
  });


  // -----------------------------
  //  SMOOTH TRACKPAD SCROLL
  // -----------------------------
  let scrolling = false;

  $('.way_to_use_flex').off('wheel'); // ❗ duplicate event remove

  $('.way_to_use_flex').on('wheel', function (e) {

    const deltaX = e.originalEvent.deltaX;
    const deltaY = e.originalEvent.deltaY;

    // Only horizontal gestures
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      e.preventDefault();

      if (scrolling) return;
      scrolling = true;

      if (deltaX > 0) {
        $(this).slick('slickNext');
      } else {
        $(this).slick('slickPrev');
      }

      setTimeout(() => (scrolling = false), 420); // match slick speed
    }
  });

});

document.addEventListener("DOMContentLoaded", function () {
  var loaded = false;

  function loadLazyVideo() {
    if (loaded) return;
    loaded = true;

    // Select all review-videos divs
    var wrappers = document.querySelectorAll(".review-videos");
    wrappers.forEach(function(wrapper) {
      var videoSrc = wrapper.getAttribute("data-video-src");
      if(videoSrc) {
        wrapper.innerHTML = `
          <video 
            src="${videoSrc}" 
            srclang="en" 
            loop 
            muted 
            autoplay 
            playsinline 
            preload="none" 
            loading="lazy" 
            controls="true">
          </video>
        `;
      }
    });

    // Remove event listeners
    interactionEvents.forEach(event =>
      window.removeEventListener(event, loadLazyVideo)
    );
  }

  const interactionEvents = ['scroll', 'mousemove', 'touchstart', 'keydown'];
  interactionEvents.forEach(event =>
    window.addEventListener(event, loadLazyVideo, { once: true })
  );
});